// Meta (Facebook) Pixel setup.
// NOTE: Verify this ID matches the one shown in Meta Events Manager exactly.
export const META_PIXEL_ID = '28181910391396520'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel base code and initializes the pixel.
 * Does NOT fire the initial PageView here — PixelTracker fires PageView on
 * every route change (including the first load) so SPA navigations are tracked.
 */
export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', META_PIXEL_ID)
}

/** Fires a standard PageView event. */
export function trackPageView(): void {
  window.fbq?.('track', 'PageView')
}

/** Fires a standard Lead conversion event. */
export function trackLead(): void {
  window.fbq?.('track', 'Lead')
}
